module.exports = __webpack_public_path__ + "img/slider-right.aaf53c43.svg";